import { BRAND_LIST_ACTION } from "core/constants/Actions";
import { Action } from "core/models/ActionTypes";
import { Brand } from "core/models/Brand";

const intialState: { brands: Brand[]; count: number; isLoading: boolean } = {
  brands: [],
  isLoading: false,
  count: 0,
};

interface ActionType extends Action {
  payload: { brands: Brand[]; count: number };
}

export default function brandListReducer(state = intialState, action: ActionType) {
  switch (action.type) {
    case BRAND_LIST_ACTION.REQUEST:
      return { ...state, isLoading: true };
    case BRAND_LIST_ACTION.SUCCESS:
      const { brands, count } = action.payload;
      return { ...state, brands, count, isLoading: false };
    case BRAND_LIST_ACTION.FAILURE:
      return { ...state, ...intialState };
    default:
      return state;
  }
}
